import React from "react";
import { createPortal } from "react-dom";
import { FaInfoCircle, FaTimes } from "react-icons/fa";

const RateLimitModal = ({
  isOpen,
  serverMessage,
  supportMessage,
  onClose,
  title = "Rate limit exceeded",
  confirmLabel = "I understand",
}) => {
  if (!isOpen || typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div className="fixed inset-0 z-[10000] bg-black/50 backdrop-blur-sm px-4 flex items-center justify-center">
      <div className="relative w-full max-w-md rounded-3xl bg-white p-6 text-center shadow-2xl">
        <button
          type="button"
          aria-label="Close rate limit notice"
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 transition"
          onClick={onClose}
        >
          <FaTimes size={18} />
        </button>
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
          <FaInfoCircle size={28} />
        </div>
        <h2 className="text-2xl font-semibold text-gray-900 pb-2 flex w-full items-center justify-center">
          {title}
        </h2>
        {supportMessage && (
          <p className="mt-2 text-sm text-gray-600">{supportMessage}</p>
        )}
        {/* {serverMessage && (
          <p className="mt-4 rounded-2xl bg-primary/5 px-4 py-3 text-sm font-medium text-primary">
            {serverMessage}
          </p>
        )} */}
        <button
          type="button"
          onClick={onClose}
          className="mt-6 inline-flex w-full items-center justify-center rounded-xl bg-primary px-4 py-3 text-white font-semibold shadow-lg shadow-primary/30 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 hover:bg-primary-dark"
        >
          {confirmLabel}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default RateLimitModal;
